$(document).ready(function(){

  // $('a').click(function(){
  //   $('.f-page-transition').addClass('fade-in');
  //   $('.f-page-transition').removeClass('fade-out');
  // });
  
  $('.slick-slider-custom').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 200,
  slidesToShow: 1,
  slidesToScroll: 1, 
  //  autoplay: true,
  // autoplaySpeed: 5000,
});
  $('.customers_in_action_grid').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 2, 
    draggable: true,
   autoplay: true,
  autoplaySpeed: 5000,
    centerMode: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
});


// $('.custom-slider').slick({
//   dots: false,
//   arrows: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   centerMode: true,
//   // centerPadding: '5%',
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 4,
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 3,
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });

// if ($(window).width() < 960) {
// $('.press-section ul').slick({
//     dots: false,
//   arrows: false,
//   infinite: false,
//   speed: 300,
//   slidesToScroll: 1,
// slidesToShow: 2
// });
// }


// Hide header on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.sticky-header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If scrolled down and past the navbar, add class .nav-up.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.sticky-header').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('.sticky-header').removeClass('nav-up').addClass('nav-down');
        }
    }
  
    lastScrollTop = st;
}

$('.customers_in_action_items button.videoplabtn').click(function(){
    $(this).parent().addClass('playing').find('video').trigger('play');
    $(this).parent().parent().siblings().find('video').trigger('pause');
  $(this).parent().parent().siblings().find('.customers_in_action_items').removeClass('playing');
});

$('.customers_in_action_items video').click(function(){
    $(this).parent().removeClass('playing').find('video').trigger('pause');
});


$(document).ready(function(){
  $('button.btn.btn--plain.btn--icon.site-header__search-toggle').click(function(){
    $('html').css('prevent-scroll2');
  });
  $('drawer-closer.f-drawer__close.btn.btn--plain, .f-drawer-search .f-drawer__overlay').click(function(){
    $('html').css('prevent-scroll2');
  });
});

// if(window.location.href.includes('/product')){
// window.onscroll = function() {myFunction()};
// var header = document.querySelector(".sticky-atc-bar");
// var sticky = header.offsetTop;
//   if (window.pageYOffset < sticky) {
//     header.classList.add("hide");
//   } else {
//     header.classList.remove("hide");
//   }
// function myFunction() {
//   if (window.pageYOffset < sticky) {
//     header.classList.add("hide");
//   } else {
//     header.classList.remove("hide");
//   }
// }
// }
$(window).on('load',function(){
  setTimeout(function() {
    },700);
$('#rap__med__instagram img.lazyload').each(function(){
  let src=$(this).attr('data-src');
$(this).attr('src',src);
})
  

});
$(".custom_prdrating").click(function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $(".product_review_section").offset().top
    }, 2000);
});




setInterval(fun, 250);
function fun() {
 let textv=$('.showsizechart').find('#embeddedMySize').find('._3xw04').text();
    let modtext=textv.replace('My Size is:',"");
     if(textv.includes('My Size is')){
     $('.showsizechart').find('.extratext').text(modtext);
        $('.showsizechart').find('img').show();
     }
  else if(textv.includes('No Matching')){
    $('.showsizechart').find('.extratext').text("Size not found");
    $('.showsizechart').find('img').hide();
  }
    else{
      $('.showsizechart').find('.extratext').text("Get help");  
      $('.showsizechart').find('img').show();
    }
}



 function isSafari() {
      return /^((?!chrome).)*safari/i.test(navigator.userAgent);
  }
//Check if MAC
     if(navigator.userAgent.indexOf('Mac')>1){
        document.querySelector('html').classList.add("safari_b");
     }
else{
  document.querySelector('html').classList.remove("safari_b");
}



// $('.read_more_description').click(function(){
//     $(this).parent().find('.fulldescription').slideDown();
//     $(this).parent().find('.read_more_description').hide();
//     $(this).parent().find('.read_less_description').show();

// $('.read_less_description').click(function(){
//     $(this).parent().find('.fulldescription').slideUp();
//     $(this).parent().find('.read_more_description').show();
//     $(this).parent().find('.read_less_description').hide();
// });
    
//     $(window).scroll(function(){
//     $('.f-product__description .fulldescription').slideUp();
//           $('.shortdescription').find('.read_more_description').show();
//     $('.shortdescription').find('.read_less_description').show();
// })
// })
$('.shortdescription').click(function(){
    $(this).toggleClass('fulldescription');
})

// $(".f-product-single .f-product__media .f-image>img").imgViewer2({

//   // zoom step
//   zoomStep: 0.5,

//   // the limit on the maximum zoom level of the image
//   zoomMax: 5,

//   // is zoomable
//   zoomable: true,

//   // is draggable
//   dragable: true,

//   // callbacks
//   onClick: $.noop,
//   onReady: $.noop
  
// });


if (window.matchMedia('(min-width: 768px)').matches)
{
    if(window.location.href.includes('/product')){
  var header = document.querySelector(".f-product-single__block--customdescription");
      var header2 = document.querySelector(".f-product-single__block--customdescription .shortdescription");
  var sticky = header.offsetTop;
      window.onscroll = function() {myFunction()};
  
  function myFunction() {
  
    if (window.pageYOffset > sticky) {
          header2.classList.remove('fulldescription');
    }
  }
  }
} 




if (window.matchMedia('(max-width: 767px)').matches)
{
$(document).ready(function() {
$(".shortdescription").click(function() {
     $('html, body').animate({
         scrollTop: $(".shortdescription").offset().top
     }, 1000);
 });
$(".shortdescription.fulldescription").click(function() {
     $('html, body').animate({
         scrollTop: $(".shortdescription").offset().top
     }, 0);
 });
});
} 



jQuery(document).ready(function(e) {
    var WindowHeight = jQuery(window).height();

    var load_element = 0;

    //position of element
    var scroll_position = jQuery('.hero-section').offset().top;

    var screen_height = jQuery(window).height();
    var activation_offset = 0;
    var max_scroll_height = jQuery('body').height() + screen_height;

    var scroll_activation_point = scroll_position - (screen_height * activation_offset);

    jQuery(window).on('scroll', function(e) {

        var y_scroll_pos = window.pageYOffset;
        var element_in_view = y_scroll_pos > scroll_activation_point;
        var has_reached_bottom_of_page = max_scroll_height <= y_scroll_pos && !element_in_view;

        if (element_in_view || has_reached_bottom_of_page) {
            jQuery('#shopify-section-sticky-atc-bar').addClass("change");
        } else {
            jQuery('#shopify-section-sticky-atc-bar').removeClass("change");
        }

    });

});

$(document).ready(function(){
  
  $('.main--links').click(function() {
    var isOpen = $(this).hasClass('open');
    $('.main--links').removeClass('open');
    if (!isOpen) {
      $(this).addClass('open');
    }
  });

  // Get the product price element
    // var priceElement = $('.f-price-item');
    
    // // Loop through each element
    // priceElement.each(function() {
    //   // Get the text value of the element
    //   var priceText = $(this).text();
    
    //   // Remove the decimal point and trailing zeros
    //   var formattedPrice = parseFloat(priceText).toFixed(0);
    
    //   // Update the element with the formatted price
    //   $(this).text(formattedPrice);
    // });
  
});